import React, { useEffect } from "react";
import s from "../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import CardComponent from "../../../shared/components/Card/CardComponent";
import Filter from "../../../shared/components/Filter/ui/Filter";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPrevious from "@mui/icons-material/SkipPrevious";
import {
  searchProperties,
  clearResults,
} from "../../../shared/components/Filter/model/filterSlice";
import { toast } from "react-toastify";
import { endpointMap } from "../../../data/Fields";
import { fetchProperties } from "../../General/model/propertiesSlice";
import useAuth from "../../../hooks/useAuth";

const buttons = [];

const MyProperties = () => {
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const token = auth?.access_token;
  const agent_id = useSelector((state) => state.auth.agent_id);
  const { data, pageSize, total, totalPages, status } = useSelector(
    (state) => state.properties,
  );
  const { loading, results } = useSelector((state) => state.filter);

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const filtersFromUrl = searchParams.get("filters")
    ? JSON.parse(searchParams.get("filters"))
    : {};

  // Fetch data whenever URL parameters change
  useEffect(() => {
    dispatch(
      fetchProperties({
        token,
        agent_id,
        page: currentPage,
        pageSize,
        ...filtersFromUrl,
      }),
    );
  }, [searchParams, token, agent_id, pageSize, dispatch]);

  const handlePageChange = (newPage) => {
    setSearchParams((prev) => {
      prev.set("page", newPage.toString());
      return prev;
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onSubmit = async (formData) => {
    const params = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value) {
        if (key === "property_type") {
          if (value === "Дома и участки") {
            params[key] = "дома";
          } else if (endpointMap[value]) {
            params[key] = value.toLowerCase();
          }
        } else if (key === "agents") {
          params["agent_id"] = value;
        } else if (key === "property_condition") {
          params[key] = value.toLowerCase();
        } else if (key === "transaction_type") {
          params[key] = value.toLowerCase();
        } else if (key === "land_type") {
          params[key] = value.toLowerCase();
        } else {
          params[key] = value;
        }
      }
    });

    if (!params.agent_id) {
      params.agent_id = agent_id;
    }

    setSearchParams({
      page: "1",
      filters: JSON.stringify(params),
    });

    dispatch(fetchProperties({ token, agent_id, page: 1, pageSize, ...params }))
      .unwrap()
      .then((result) => {
        if (!result.data || result.data.length === 0) {
          toast.info("Нет данных по вашему запросу.");
        } else {
          toast.success("Поиск завершен!");
        }
      })
      .catch((error) => toast.error(error));
  };

  const onClear = () => {
    dispatch(clearResults());
    setSearchParams({ page: "1" });
    dispatch(fetchProperties({ token, agent_id, page: 1, pageSize }));
    toast.info("Фильтры сброшены. Показаны ваши объекты.");
  };

  // Reusable pagination controls to avoid code duplication
  const PaginationControls = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: 20,
        marginTop: "20px",
        marginBottom: "15px",
      }}
    >
      <button
        style={{ cursor: "pointer" }}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <SkipPrevious />
      </button>
      <span>
        {currentPage} из {totalPages}
      </span>
      <button
        style={{ cursor: "pointer" }}
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        <SkipNextIcon />
      </button>
    </div>
  );

  return (
    <div className="container">
      <Filter
        onSubmit={onSubmit}
        results={results}
        loading={loading}
        hideAgents
        onClear={onClear}
      />
      {/* Pagination at the top, above the listings */}
      <PaginationControls />

      <h1
        style={{
          color: "rgba(19, 19, 19, 0.7)",
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 30,
          textAlign: "center",
        }}
      >
        Показано {(currentPage - 1) * pageSize + 1} –{" "}
        {Math.min(currentPage * pageSize, total)} из {total}
      </h1>

      <div className={s.cardBlock}>
        {status === "loading" ? (
          <div className={s.loadingWrapper}>
            <div className="loader"></div>
          </div>
        ) : data && data.length > 0 ? (
          data.map((item) => (
            <CardComponent key={item.id} item={item} buttons={buttons} />
          ))
        ) : (
          <p>Нет данных</p>
        )}
      </div>

      {/* Pagination at the bottom (original position) */}
      <PaginationControls />
    </div>
  );
};

export default MyProperties;
